const otpEmail = {
  subject: 'Kod za potvrdu:',
  body: {
    title: 'Vaš jednokratni kod za potvrdu za VoiceFill Medical:',
    expiration: 'Ovaj kod vrijedi 15 minuta.',
  },
};

export default otpEmail;
